import React, { useState, useEffect } from "react";
import { Form, Modal } from "react-bootstrap";

const RFQOfferEditProjectName = ({ show, currentName, onSave, onCancel }) => {
    const [prefix, setPrefix] = useState("");
    const [editablePart, setEditablePart] = useState("");

    useEffect(() => {
        if (currentName) {
            const lastDashIndex = currentName.lastIndexOf("-");
            const prefixPart = currentName.substring(0, lastDashIndex);
            const editable = currentName.substring(lastDashIndex + 1);

            setPrefix(prefixPart);
            setEditablePart(editable);
        }
    }, [currentName]);

    if (!show) return null;

    const handleSave = () => {
        if (editablePart.trim()) {
            onSave(`${prefix}-${editablePart}`);
        }
    };

    const handleCancel = () => {
        onCancel(currentName);
    };

    return (
        <Modal show={show} onHide={handleCancel} centered className="edit-project-name-modal">
            <Modal.Header closeButton>
                <Modal.Title className="sub-header">Edit Project Name</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    <Form.Label>Project Name</Form.Label>
                    <div className="d-flex">
                        <Form.Control
                            type="text"
                            value={prefix}
                            disabled
                            className="me-2"
                            style={{ flex: "1" }}
                        />
                        <span style={{ padding: "0.5rem 0.25rem" }}>-</span>
                        <Form.Control
                            type="text"
                            maxLength={50}
                            value={editablePart}
                            onChange={(e) => setEditablePart(e.target.value)}
                            placeholder="Enter project name"
                            style={{ flex: "1" }}
                        />
                    </div>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <button className="border-btn" onClick={handleCancel}>
                    Cancel
                </button>
                <button
                    className="primary-btn"
                    onClick={handleSave}
                    disabled={!editablePart.trim()}
                >
                    Save
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default RFQOfferEditProjectName;
